import useSWR from "swr";
import useUser from "../../context/userHook";
import { getBoardSettings, updateBoardSettings } from "../../../utils/requests/boardSettingsRequest";
import useTokenHook from "../../context/useTokenHook";
import logger from "../../../lib/logger";
import { useState } from "react";
import mondaySdk from "monday-sdk-js";

const monday = mondaySdk();

const useBoardSettings = (boardId: number) => {
  const { userId } = useUser();
  const { token } = useTokenHook();
  const [updateSettingLoading, setUpdateSettingLoading] = useState(false);
  const [updateSettingError, setUpdateSettingError] = useState<Error | null>(null);

  const { error, data, isLoading, mutate, isValidating } = useSWR(token && userId && boardId ? `board-settings:${userId}:${boardId}` : null, () =>
    getBoardSettings(token!, boardId)
  );

  const updateBoardSetting = async (type: string, settingKey: string, value: any, excludedBoards?: string[]) => {
    setUpdateSettingLoading(true);
    setUpdateSettingError(null);
    try {
      await updateBoardSettings(token!, boardId, type, settingKey, value, excludedBoards);
      await mutate();
      monday.execute("notice", {
        message: `${type === "updates" || type === "subitems" ? type.toUpperCase() : ""} ${settingKey
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")} has been ${type === "updates" || type === "subitems" ? "updated" : value ? "enabled" : "disabled"}`,
        type: "success",
        timeout: 5000,
      });
    } catch (err: any) {
      setUpdateSettingError(err);
      logger.error(`Error updating ${settingKey} setting:`, err);
      monday.execute("notice", {
        message: `Failed to update ${settingKey
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}`,
        type: "error",
        timeout: 5000,
      });
      throw err;
    } finally {
      setUpdateSettingLoading(false);
    }
  };

  return {
    isLoading,
    error,
    boardSettingsData: data || null,
    mutate,
    isValidating,
    updateBoardSetting,
    updateSettingLoading,
    updateSettingError,
  };
};

export default useBoardSettings;
